// Auto-extracted from translations.js — Zitro Property Management i18n
const it = {
  nav: {
    about: "Chi Siamo",
    protocol: "Il Metodo",
    services: "Servizi",
    concierge: "Concierge",
    portfolio: "Portfolio",
    blog: "Blog",
    insights: "Insights",
    contact: "Contatti",
    cta: "Parliamone",
  },
  hero: {
    overline: "Zitro — Property Management · Basati a Como, sul territorio",
    line1: "Un metodo collaudato.",
    line2: "Ogni immobile,",
    line3: "curato",
    line3Accent: "come fosse l'unico.",
    subtitle:
      "Siamo di Como e siamo sul territorio. Ogni proprietà viene seguita da un team locale che conosce il Lago come casa propria — persone reperibili in tempi certi, presenti fisicamente su ogni immobile che gestiamo. Un modello operativo collaudato dietro le quinte, una presenza umana e discreta davanti. Perché nei dettagli fanno la differenza — e i dettagli, sul Lago di Como, si vedono e si vivono ogni giorno.",
    ctaPrimary: "Parlaci del tuo immobile",
    ctaSecondary: "Scopri il metodo",
    scroll: "Scorri",
  },
  marquee: [],
  about: {
    overline: "01 — Chi siamo",
    title: "Non gestiamo proprietà.\nSiamo custodi del loro valore.",
    lead:
      "Ogni proprietà ha un'identità, una storia e un valore da preservare. Zitro nasce per offrire agli immobili di pregio sul Lago di Como una gestione evoluta, capace di coniugare performance, tutela del patrimonio e attenzione costante ai dettagli. Un approccio sartoriale, sostenuto da processi rigorosi, competenze specializzate e una visione orientata al lungo periodo. Perché gestire significa occuparsi del presente. Custodire significa accrescere il valore nel tempo.",
    chapters: [
      {
        n: "01",
        title: "Attenzione totale",
        body: "Ogni immobile è un unicum, e viene trattato come tale. Architettura, storia, staff, ospiti, obiettivi del proprietario: nulla è mai generalizzato. Ogni scelta operativa nasce dall'ascolto della singola proprietà — come se fosse l'unica di cui ci occupiamo.",
      },
      {
        n: "02",
        title: "Metodo collaudato",
        body: "L'attenzione totale non è improvvisazione. Dietro ogni intervento c'è un modello operativo verificato in anni sul Lago di Como: procedure documentate, ruoli dedicati, controlli qualità continui. È la struttura solida che ci permette di essere sartoriali senza mai essere fragili.",
      },
      {
        n: "03",
        title: "Serenità del proprietario",
        body: "Comunicazione puntuale, report chiari, decisioni tracciabili, spese sempre motivate. Zero confusione, zero zone grigie. Massimizzi i guadagni senza pensieri — mentre torni a vivere ciò che possiedi.",
      },
      {
        n: "04",
        title: "Cura dell'ospite",
        body: "Ogni ospite viene selezionato, verificato e accolto in presenza dal nostro staff qualificato. Contratto firmato, carta di credito a garanzia, polizza RC Terzi sempre attiva. La sicurezza dell'immobile è la nostra prima forma di rispetto.",
      },
    ],
  },
  protocol: {
    overline: "02 — Il Metodo Zitro",
    title: "Un metodo rigoroso.\nUna cura senza compromessi.",
    lead:
      "Il Metodo Zitro unisce strategia, organizzazione e controllo in ogni fase della gestione. Procedure definite, responsabilità chiare e verifiche costanti ci permettono di seguire ogni proprietà con precisione, continuità e attenzione autentica. Non standardizziamo gli immobili: standardizziamo la qualità con cui ce ne prendiamo cura. Perché ogni proprietà è diversa, ma il livello di eccellenza non può esserlo.",
    roles: [
      {
        n: "01",
        label: "Controllo",
        title: "Standard verificati\na ogni soggiorno",
        body: "Un responsabile qualità dedicato verifica ogni procedura sulla tua proprietà. Ispezioni tracciate, standard misurabili, non conformità corrette in tempo reale. Il risultato è un immobile sempre alla sua migliore forma — anche quando tu non ci sei.",
      },
      {
        n: "02",
        label: "Assistenza",
        title: "Un unico interlocutore,\nzero rimpalli",
        body: "Un customer service dedicato per te e per gli ospiti, reperibile ogni giorno. Nessun call center, la stessa voce sempre. Le richieste vengono risolte prima che diventino problemi, con reportistica puntuale e comunicazione ordinata.",
      },
      {
        n: "03",
        label: "Cura",
        title: "Manutenzione predittiva,\nvalore che cresce",
        body: "Squadra interna sulle ville storiche e dimore contemporanee, artigiani locali attivabili in 24 ore. Piani costruiti sull'immobile — mai a catalogo. Ogni intervento è pensato per lasciare la proprietà un po' più preziosa di come l'abbiamo trovata.",
      },
      {
        n: "04",
        label: "Housekeeping",
        title: "Ogni check-in\nè un debutto",
        body: "Turn-over silenziosi, ispezioni fotografiche dopo ogni ospite, cura dei tessuti, delle collezioni d'arte e degli arredi delicati. Personale formato sui protocolli dell'ospitalità di lusso. La tua casa riceve gli ospiti come se li stessi aspettando tu.",
      },
      {
        n: "05",
        label: "Performance",
        title: "Ricavo netto,\nnon occupazione",
        body: "Revenue manager dedicato, pricing aggiornato ogni giorno leggendo mercato, stagionalità ed eventi. Analisi trimestrali, benchmark documentati, decisioni tracciabili. L'obiettivo non è riempire il calendario: è massimizzare il netto della tua singola proprietà.",
      },
    ],
  },
  services: {
    overline: "03 — Servizi",
    title: "Un unico interlocutore.\nUn sistema completo.",
    lead:
      "Ogni proprietà viene seguita attraverso un modello organizzativo preciso, costruito sulle sue caratteristiche e sulle esigenze del proprietario. Competenze, attività e responsabilità vengono coordinate all'interno di un unico sistema di gestione.",
    items: [
      {
        k: "SVC 01",
        title: "Gestione integrata",
        body: "Una regia operativa costruita intorno alla proprietà: coordinamento del personale, manutenzioni, forniture, sicurezza e adempimenti amministrativi. Un unico interlocutore supervisiona ogni attività, assicurando continuità e controllo.",
      },
      {
        k: "SVC 02",
        title: "Revenue & Distribution",
        body: "Strategie tariffarie dinamiche, analisi continua della domanda e distribuzione sui canali più coerenti con il posizionamento della proprietà. Ottimizziamo redditività e qualità delle prenotazioni senza comprometterne il valore percepito.",
      },
      {
        k: "SVC 03",
        title: "Concierge & Ospitalità",
        body: "Esperienze e servizi su misura, coordinati attraverso una rete selezionata di professionisti e partner del territorio. Ogni richiesta viene gestita con discrezione, precisione e attenzione alle preferenze dell'ospite.",
      },
      {
        k: "SVC 04",
        title: "Progetti & Valorizzazione",
        body: "Coordiniamo architetti, imprese e artigiani selezionati per interventi di miglioramento e riqualificazione. Supervisioniamo tempi, costi e qualità esecutiva, tutelando l'identità della proprietà.",
      },
      {
        k: "SVC 05",
        title: "Property Advisory",
        body: "Analizziamo performance, costi e potenziale dell'immobile per supportare decisioni più consapevoli. Report periodici e scenari previsionali restituiscono una visione chiara dei risultati e delle opportunità future.",
      },
      {
        k: "SVC 06",
        title: "Interior & Styling",
        body: "Curiamo l'immagine della proprietà attraverso styling, aggiornamento degli ambienti e preparazione per shooting e soggiorni. Ogni scelta valorizza spazi, materiali e identità, migliorando presentazione ed esperienza.",
      },
      {
        k: "SVC 07",
        title: "Strategia Fiscale",
        body: "Zitro adotta un sistema di gestione fiscale strategico, costruito insieme a commercialisti specializzati nel real estate di pregio. Permette di ottenere vantaggi fiscali fino al 40% sulla tassazione dei ricavi da locazione — sia per proprietari privati sia per società — combinando regime cedolare, ammortamenti, deduzioni e strutturazioni societarie coerenti con il patrimonio.",
      },
    ],
  },
  cinematic: {
    overline: "Lago di Como · L'esperienza",
    title: "I dettagli\nfanno la differenza.",
    body:
      "Il vero lusso non sono gli oggetti — è l'esperienza di una vacanza pensata in ogni gesto. Il ritmo delle giornate, il silenzio giusto al momento giusto, i tempi rispettati, la sensazione di sentirsi a casa senza aver mai visto quella casa prima. Curiamo il design dell'esperienza, non l'apparenza — perché un soggiorno sul Lago di Como diventa memoria solo quando ogni dettaglio, invisibile, è al suo posto.",
  },
  portfolio: {
    overline: "04 — Portfolio",
    title: "Selezione.\nNon collezione.",
    subtitle:
      "Gestiamo un numero volutamente limitato di asset. Ogni immobile riceve un piano di valorizzazione unico e attenzione totale — perché il vero servizio sartoriale non è scalabile all'infinito, e non deve esserlo.",
    viewAll: "Portfolio completo",
  },
  caseStudy: {
    overline: "05 — Case Study",
    title: "Guadagni superiori,\nrisultati documentati.",
    lead:
      "Con Zitro non ci raccontiamo — misuriamo. Ogni proprietà sotto la nostra custodia genera KPI oggettivi, tracciati mese per mese e certificati trimestralmente. Nessuna sensazione personale: solo dati che dimostrano che con la gestione Zitro gli immobili rendono di più.",
    docBadge: "Ogni KPI è documentato e verificato — audit trimestrale disponibile per il proprietario",
    property: {
      name: "Regina 35 — Carate Urio",
      typology: "180 m² · 3 camere · 3 bagni",
      cover: "https://customer-assets-jai6qajn.emergentagent.net/job_como-properties/artifacts/2khprcdp_Carate%20Urio-35%20%281%29.webp",
    },
    challenge: {
      label: "Il contesto — prima di Zitro",
      title: "Una proprietà sottoperformante,\nsenza dati.",
      body: "Gestione generalista, pricing statico impostato una volta l'anno, ospiti non selezionati, manutenzioni reattive attivate solo dopo il guasto. Report annuali via email, senza tracciabilità delle decisioni né confronto con benchmark di mercato.",
    },
    approach: {
      label: "Il metodo Zitro — dodici mesi dopo",
      title: "Regia unica, misurazione continua,\npresenza sul territorio.",
      body: "Team locale attivo entro 20 minuti dalla proprietà, revenue manager con pricing aggiornato ogni giorno su dati di mercato in tempo reale, protocolli di selezione ospiti tracciati, piano di manutenzione predittiva. Ogni decisione registrata, ogni euro giustificato in un report trimestrale audit-ready.",
    },
    metricsHeader: "12 mesi di gestione Zitro. Numeri verificati.",
    metrics: [
      { k: "+34%", label: "Ricavo netto proprietario", note: "Vs. 12 mesi precedenti · fonte: rendiconto trimestrale certificato" },
      { k: "+22%", label: "ADR medio (€/notte)", note: "Pricing dinamico, dati Airdna + benchmark diretti" },
      { k: "+18 pp", label: "Occupancy rate", note: "Dal 47% al 65% · calendari Zitro tracciati" },
      { k: "9.6/10", label: "Rating medio ospiti", note: "Su 78 recensioni verificate (Airbnb, Booking, dirette)" },
      { k: "0", label: "Emergenze irrisolte >2h", note: "Log SLA squadra locale · reperibilità 24/7" },
      { k: "100%", label: "Interventi tracciati", note: "Ogni ticket firmato, foto ante/post, report proprietario" },
    ],
    quote:
      "Prima ricevevo report generici e nessuno mi diceva perché una scelta era stata fatta. Con Zitro ogni euro è motivato, ogni decisione ha un numero dietro. E i numeri parlano: la villa oggi rende un terzo in più, senza che io debba pensarci.",
    quoteAuthor: "Proprietario, Regina 35",
    cta: "Richiedi un'analisi come questa per la tua proprietà",
  },
  testimonials: {
    overline: "06 — Fiducia",
    title: "La fiducia\nsi costruisce nel tempo.",
  },
  insights: {
    overline: "06 — Le Lettere di Zitro",
    title: "Le Lettere\ndi Zitro.",
    lead: "Una lettera al mese su ospitalità, proprietà e cultura del Lago di Como. Pensieri lenti, direttamente nella tua casella.",
    readMore: "Leggi",
  },
  newsletter: {
    overline: "Newsletter · Le Lettere di Zitro",
    title: "Pensieri lenti,\ndirettamente nella tua casella.",
    lead: "Una lettera al mese su gestione, cultura e mercato del Lago di Como. Solo scritti curati — mai spam, mai rumore.",
    placeholder: "Il tuo indirizzo email",
    submit: "Iscrivimi",
    success: "Grazie. Ci sentiamo presto.",
    error: "Qualcosa non ha funzionato. Riprova.",
    disclaimer: "Uso solo per l'invio della newsletter. Nessuna condivisione con terzi.",
    viewAll: "Tutti gli articoli",
  },
  contact: {
    overline: "07 — Contatti",
    title: "Scriviamoci.",
    subtitle:
      "Le collaborazioni migliori nascono da conversazioni riservate. Raccontaci il tuo immobile: cominciamo a costruire, insieme, un piano di valorizzazione su misura.",
    form: {
      name: "Nome e cognome",
      email: "Email",
      phone: "Telefono (opzionale)",
      type: "Tipologia di asset",
      message: "Come possiamo aiutarti?",
      submit: "Invia richiesta",
      sending: "Invio in corso…",
      success: "Grazie. Ti risponderemo entro 24 ore.",
      error: "Qualcosa non ha funzionato. Riprova.",
      consentRequired: "Per procedere devi accettare l'informativa sulla privacy.",
      options: [
        "Villa privata",
        "Dimora storica",
        "Attico",
        "Palazzo",
        "Progetto in restauro",
        "Altro",
      ],
    },
    infoTitle: "Contatti",
    infoAddress: "Via Cinque Giornate 76/L\nCernobbio (CO) — Italia",
    infoEmail: "info@zitroapartments.com",
    infoPhone: "+39 375 7410 999",
    infoWebsite: "www.zitroapartments.com",
    whatsapp: "Scrivici su WhatsApp",
    whatsappMsg: "Salve, ho una struttura sul Lago di Como e vorrei richiedere informazioni",
  },
  footer: {
    claim: "Il Metodo Zitro — Property Management sul Lago di Como",
    motto: "I dettagli fanno la differenza.",
    rights: "Tutti i diritti riservati.",
    lang: "Lingua",
  },
  audiences: {
    overline: "A chi ci rivolgiamo",
    title: "Un metodo,\ntre interlocutori.",
    lead:
      "Zitro parla la lingua di chi conosce il valore di un immobile — e ne pretende una gestione all'altezza. Che si tratti di un proprietario privato, di una holding o di un professionista che rappresenta un cliente, il metodo è lo stesso: cura totale, discrezione, risultati misurabili.",
    items: [
      {
        k: "01",
        title: "Proprietari",
        body: "Per chi possiede un immobile di pregio e cerca un partner che lo custodisca come farebbe lui stesso. Massimizzi i ricavi, mantieni la serenità, torni a vivere la casa senza pensieri operativi. Interlocutore unico, decisioni sempre condivise.",
      },
      {
        k: "02",
        title: "Società",
        body: "Per family office, holding immobiliari e realtà corporate che vogliono trasformare gli asset in performance misurabili. Report trimestrali, ottimizzazione fiscale, strategia di detenzione, exit strategy documentata. Numeri chiari, decisioni tracciabili.",
      },
      {
        k: "03",
        title: "Professionisti",
        body: "Per notai, avvocati, wealth advisor e broker fiduciari che cercano un gestore affidabile a cui affidare la clientela più esigente. La nostra discrezione diventa un'estensione della vostra professionalità — sempre riservata, sempre allineata.",
      },
    ],
  },
  partners: {
    overline: "Certificazioni & Riconoscimenti",
    title: "Accreditati.\nRiconosciuti.\nPremiati.",
    lead:
      "Zitro opera secondo standard verificabili, riconosciuti a livello europeo, in partnership con i più prestigiosi operatori del settore luxury real estate. Le nostre proprietà sono riconosciute dalle piattaforme leader di mercato per la qualità dell'ospitalità offerta.",
    items: [
      {
        label: "Riconoscimento Airbnb",
        name: "Superhost",
        body: "Riconoscimento Superhost su Airbnb: le nostre proprietà mantengono un tasso di risposta superiore al 90%, valutazione media oltre 4.8 stelle e cancellazioni pressoché azzerate. Uno status che si conferma trimestre dopo trimestre.",
      },
      {
        label: "Booking.com Award",
        name: "Traveller Review Award",
        body: "Traveller Review Award di Booking.com — assegnato agli host con recensioni ospiti costantemente eccellenti (rating medio ≥ 8.5). Un riconoscimento pubblico e verificabile della qualità del nostro servizio.",
      },
      {
        label: "Partnership Certificata Europea",
        name: "Luxforsale",
        body: "Partner certificato Luxforsale a livello europeo — network di riferimento per il property management luxury. Un canale diretto verso family office, Ultra HNWI e la clientela internazionale più esigente del real estate di pregio.",
      },
      {
        label: "Associazione di Categoria",
        name: "AIGAB",
        body: "Membri dell'Associazione Italiana Gestori Affitti Brevi. Contribuiamo alla definizione di best practice e standard operativi del settore in Italia.",
      },
    ],
  },
  simulator: {
    overline: "Simulatore Ricavi",
    title: "Uno standard.\nUn ordine di grandezza.",
    lead:
      "Uno strumento indicativo basato su dati Airdna aggregati del mercato Lago di Como. Le stime sono conservative e riflettono un netto proprietario tipico dopo commissioni, costi operativi e imposte. Il modello reale che applichiamo alla tua proprietà è sartoriale: contattaci per un'analisi puntuale.",
    typeLabel: "Tipologia di immobile",
    types: [
      { key: "attico", label: "Attico / Appartamento", adr: 620 },
      { key: "dimora", label: "Dimora storica", adr: 950 },
      { key: "villa", label: "Villa fronte lago", adr: 1400 },
      { key: "palazzo", label: "Palazzo / Estate", adr: 2100 },
    ],
    locationLabel: "Ubicazione",
    locations: [
      { key: "prime", label: "Bellagio · Cernobbio · Tremezzina", mult: 1.28 },
      { key: "standard", label: "Como · Menaggio · Lenno", mult: 1.0 },
      { key: "emerging", label: "Varenna · Blevio · altre località", mult: 0.82 },
    ],
    surfaceLabel: "Superficie",
    surfaceUnit: "m²",
    bedroomsLabel: "Camere da letto",
    seasonLabel: "Modalità di locazione",
    seasons: [
      { key: "shortterm", label: "Short-term luxury (settimane)", occ: 0.42, adrMult: 1.0 },
      { key: "mixed", label: "Mix strategico (short + medio termine)", occ: 0.66, adrMult: 0.74 },
    ],
    results: {
      adr: "ADR medio",
      nights: "Notti prenotate/anno",
      gross: "Ricavo lordo annuo",
      net: "Netto proprietario stimato",
      note: "Stima indicativa costruita sui nostri dati aggregati. Il pricing reale che applicheremo alla tua proprietà nasce dallo stesso modello, ma viene calibrato ogni giorno dal revenue manager dedicato all'immobile — nessuna intuizione al caso, solo processo.",
    },
    cta: "Richiedi analisi personalizzata",
  },
  concierge: {
    overline: "Concierge Zitro",
    hero1: "Ogni desiderio,",
    hero2: "prima che venga",
    hero3: "espresso.",
    lead:
      "Il nostro concierge non risponde: anticipa. Un unico interlocutore, un ecosistema di partner selezionati sul Lago di Como, a Milano e su tutto il Nord Italia. Elicottero, yacht, chef stellati, sommelier, guide private, auto d'epoca, wellness in villa. Portiamo dentro l'immobile ciò che l'immobile merita — sempre su misura, mai a catalogo.",
    backToHome: "Torna alla home",
    ctaTitle: "Immagina qualcosa.\nLo organizziamo.",
    ctaBody:
      "Ogni esperienza è progettata dal Quality Manager della proprietà, verificata dal Customer Service dedicato e certificata prima di essere consegnata all'ospite.",
    ctaButton: "Contattaci",
    services: [
      { k: "01", title: "Elicottero privato", body: "Transfer da Milano Linate/Malpensa o Bergamo Orio direttamente all'eliporto della proprietà. Voli scenici sul Lago di Como, sulle Alpi e sui laghi lombardi. Partner AOC certificato.", img: "https://images.unsplash.com/photo-1558597576-f1a962543f35" },
      { k: "02", title: "Yacht & Motoscafi Classici", body: "Riva Aquarama d'epoca, tender di rappresentanza, yacht privati per gite giornaliere o crociere multi-giorno. Skipper certificati, pickup dal molo privato dell'immobile.", img: "https://images.unsplash.com/photo-1567899378494-47b22a2ae96a" },
      { k: "03", title: "Chef Stellato in Villa", body: "Cene private firmate da chef Michelin, degustazioni a più mani, corsi di cucina esclusivi. Menu progettati sulle preferenze, sulle intolleranze e sulle occasioni.", img: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0" },
      { k: "04", title: "Sommelier Privato", body: "Verticali di grandi annate, degustazioni notturne sulla terrazza, visite riservate alle cantine del Franciacorta, dei Colli di Bergamo, della Valtellina.", img: "https://images.unsplash.com/photo-1510812431401-41d2bd2722f3" },
      { k: "05", title: "Autisti & Auto d'Epoca", body: "Flotta con autisti bilingue, veicoli di rappresentanza e collezione di auto storiche — dalle grandi berline classiche alle sportive d'epoca — per shooting, matrimoni e tour panoramici sul Lago di Como.", img: "https://images.unsplash.com/photo-1566238432098-35fc2fa3d908" },
      { k: "06", title: "Sicurezza & Bodyguard", body: "Personale di sicurezza discreto, close protection certificata, gestione degli accessi durante eventi privati e permanenze prolungate.", img: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b" },
      { k: "07", title: "Wellness & SPA Privata", body: "Massaggi in villa, personal trainer, yoga sul pontile all'alba, medico estetico e osteopata su richiesta. Un ritiro senza uscire di casa.", img: "https://images.unsplash.com/photo-1544161515-4ab6ce6db874" },
      { k: "08", title: "Esperienze Culturali", body: "Aperture private di Villa del Balbianello e Villa Carlotta, guide d'arte, tour di ville storiche del Lago di Como, accesso ad ateliers e collezionisti privati.", img: "https://images.unsplash.com/photo-1533105079780-92b9be482077" },
      { k: "09", title: "Accesso VIP Ristoranti", body: "Prenotazioni riservate nei ristoranti stellati del Lago di Como e di Milano. Tavoli last-minute, menu personalizzati, transfer coordinato dallo staff.", img: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4" },
      { k: "10", title: "Jet Privato", body: "Voli riservati per trasferimenti rapidi in tutta Europa. Aeroporti principali e piste minori, riservatezza assoluta, transfer coordinato da e verso l'immobile.", img: "https://images.unsplash.com/photo-1540962351504-03099e0a754b" },
    ],
  },
};

export default it;
